var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-reader", {
    attrs: { entity: "rumour", id: _vm.id, "use-sharing": false },
    scopedSlots: _vm._u(
      [
        {
          key: `reader`,
          fn: function({ doc }) {
            return [
              _c("label-value", { attrs: { name: "Name", value: doc.name } }),
              _c("label-value", {
                attrs: {
                  name: "Rumour Type",
                  value: _vm.rumourType(doc.rumourTypeText)
                }
              }),
              _c("label-value-html", {
                attrs: {
                  name: "Description",
                  value: doc.description,
                  html: true
                }
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }